'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
var ute;
(function (ute) {
  var ui;
  (function (ui) {
    var UteTooltipCms = (function (_super) {
      __extends(UteTooltipCms, _super);
      /* @ngInject */
      function UteTooltipCms(uteContentLoader, uteLocale, uteEndpoint, $timeout, $compile, $http, $templateCache) {
        var _this = this;
        _super.call(this, $timeout, $compile, $http, $templateCache);
        this.uteContentLoader = uteContentLoader;
        this.uteLocale = uteLocale;
        this.uteEndpoint = uteEndpoint;
        //endregion
        this.link = function ($scope, $element, $attrs) {
          /** returns promise */
          var getCmsPromise;
          if ($scope.ttMockCmsResponse == null) {
            getCmsPromise = function () {
              // scope.localContentId, scope.language and scope.province are always null in this version.
              // Logic below has been copied from uteContentInjector, exact replica.
              // This directive could be extended to support all these extra parameters - TBD.
              // For now we're fine with scope.clientId only - this is how it's how internet/customer-eligiblity/customer-eligiblity is being called in 2.0
              var options = {
                scope: $scope,
                element: $element,
                method: 'GET',
                dataType: 'html',
                fileType: '.html',
                contentId: $scope.contentId,
                localContentId: $scope.localContentId || undefined,
                compile: angular.isDefined($scope.compile) && $scope.compile || false,
                language: $scope.language || _this.uteLocale.language,
                province: $scope.province || _this.uteLocale.province,
                teamsiteUrl: _this.uteEndpoint('', 'teamsite')
              };
              return _this.uteContentLoader.getContent(options);
            };
          }
          else {
            getCmsPromise = function () {
              return _this.$timeout(function () {
                return $scope.ttMockCmsResponse;
              }, 1000);
            };
          }
          //region these attributes are not provided currently with content-id="internet/customer-eligiblity/customer-eligiblity"
          /*
           $scope.$watch($attrs.language, function (newValue, oldValue) {
           if (newValue !== oldValue && !isNaN(newValue)) {
           $scope.language = newValue;
           getCmsPromise();
           }
           });
           $scope.$watch($attrs.province, function (newValue, oldValue) {
           if (newValue !== oldValue && !isNaN(newValue)) {
           $scope.province = newValue;
           getCmsPromise();
           }
           });
           $scope.$watch($attrs.contentId, function (newValue, oldValue) {
           if (newValue !== oldValue && !isNaN(newValue)) {
           $scope.contentId = newValue;
           getCmsPromise();
           }
           });
           $scope.$watch($attrs.localContentId, function (newValue, oldValue) {
           if (newValue !== oldValue && !isNaN(newValue)) {
           $scope.localContentId = newValue;
           getCmsPromise();
           }
           });
           */
          //endregion
          var isTitleCreated = false;
          var onTitleTrigger = _.debounce(function () {
            if (isTitleCreated) {
              return;
            }
            isTitleCreated = true; // call only once
            var p = getCmsPromise();
            //let failFn = !p.fail ? p.catch : p.fail; // support different Promise objects
            p.catch(function () {
              isTitleCreated = false; // retry on next mouseover if AJAX call fails
            });
            $scope.ttContent = p;
            _this.doLink($scope, $element, $attrs);
          }, 200);
          $element.bind('mouseover', onTitleTrigger);
          $scope.$on('$destroy', function () {
            $element.unbind(onTitleTrigger);
          });
        };
        this.scope = angular.extend(this.scope, {
          contentId: '@',
          compile: '=?',
          ttMockCmsResponse: '=?' // temporary, for initial debugging
        });
      }
      /* @ngInject */
      UteTooltipCms.instance2 = function (uteContentLoader, uteLocale, uteEndpoint, $timeout, $compile, $http, $templateCache) {
        return new UteTooltipCms(uteContentLoader, uteLocale, uteEndpoint, $timeout, $compile, $http, $templateCache);
      };
      //region Static & Constructor
      UteTooltipCms.$inject = ['uteContentLoader', 'uteLocale', 'uteEndpoint', '$timeout', '$compile', '$http', '$templateCache'];
      return UteTooltipCms;
    }(ui.UteTooltip));
    angular.module('ute.ui').directive('uteTooltipCms', ['uteContentLoader', 'uteLocale', 'uteEndpoint', '$timeout', '$compile', '$http', '$templateCache', UteTooltipCms.instance2]);
  })(ui = ute.ui || (ute.ui = {}));
})(ute || (ute = {}));

